<template>
  <div id="stepper-form" ref="stepper">
    <v-stepper v-model="donationStep" vertical>
      <v-stepper-step id="step1" step="1" :complete="donationStep > 1" color="primary" editable @click="goToStep(1)">
        <span class="step-title">{{ t("DON") }}</span>
        <small>{{ t("TYPE_ET_MONTANT") }}</small>
      </v-stepper-step>

      <v-stepper-content step="1">
        <DonationForm @to-step="goToStep" @validateStep="montantValidated = true" @invalidateStep="montantValidated = false" />
      </v-stepper-content>

      <v-stepper-step id="step2" step="2" :complete="donationStep > 2" editable @click="goToStep(2)">
        <span>{{ t("RENSEIGNEMENTS_PERSONNELS") }}</span>
        <small>{{ t("SUR_LE_DONATEUR") }}</small>
      </v-stepper-step>

      <v-stepper-content step="2">
        <v-container>
          <v-row>
            <v-col class="mx-auto">
              <PersonalInfoForm
                @to-step="goToStep"
                @validateStep="renseignementsPersonnelsValidated = true"
                @invalidateStep="renseignementsPersonnelsValidated = false"
              />
            </v-col>
          </v-row>
        </v-container>
      </v-stepper-content>

      <v-stepper-step id="step3" step="3" :complete="donationStep > 3" editable @click="goToStep(3)">
        <span>{{ t("COORDONNEES") }}</span>
      </v-stepper-step>

      <v-stepper-content step="3">
        <v-container>
          <v-row>
            <v-col class="mx-auto">
              <ContactInfoForm @to-step="goToStep" @validateStep="coordonneesValidated = true" @invalidateStep="coordonneesValidated = false" />
            </v-col>
          </v-row>
        </v-container>
      </v-stepper-content>

      <v-stepper-step id="step4" step="4" :complete="donationStep > 4" :editable="allStepsValidated" @click="goToStep(4)">
        <span>{{ t("RECAP_ET_PAIEMENT") }}</span>
      </v-stepper-step>

      <v-stepper-content step="4">
        <donate-summary @to-step="goToStep" />
      </v-stepper-content>
    </v-stepper>
  </div>
</template>

<script>
import DonationForm from "@/components/DonationForm"
import PersonalInfoForm from "@/components/PersonalInfoForm"
import ContactInfoForm from "@/components/ContactInfoForm"
import DonateSummary from "@/components/DonateSummary"
import { mapActions, mapGetters } from "vuex"

export default {
  components: {
    DonationForm,
    PersonalInfoForm,
    ContactInfoForm,
    DonateSummary
  },
  props: {
    isLoading: {
      type: Boolean,
      default: false
    },
    dataLoaded: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    donationStep: 1,
    montantValidated: false,
    renseignementsPersonnelsValidated: false,
    coordonneesValidated: false
  }),
  computed: {
    ...mapGetters(["t"]),
    allStepsValidated() {
      return this.montantValidated && this.renseignementsPersonnelsValidated && this.coordonneesValidated
    }
  },
  methods: {
    goToStep(step) {
      if (step == 4) {
        if (this.allStepsValidated) {
          this.donationStep = step
          this.scrollToStep(step)
        }
      } else {
        this.donationStep = step
        this.scrollToStep(step)
      }
    },
    scrollToStep(step) {
      setTimeout(() => {
        this.$vuetify.goTo("#step" + step)
      }, 500)
    },

    ...mapActions(["setCampaign"])
  }
}
</script>

<style scoped>
#container {
  background-color: #f6f6f6;
}
#header {
  min-height: 200px;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
}
.background {
  /* Add the blur effect */
  -webkit-backdrop-filter: blur(5px); /* Use for Safari 9+, Edge 17+ (not a mistake) and iOS Safari 9.2+ */
  backdrop-filter: blur(5px); /* Supported in Chrome 76 */
}

@media screen and (max-width: 800px) {
  #stepper-form .v-stepper__step {
    padding: 25px 25px;
    border: 2px solid #ddd;
    border-radius: 5px;
    margin-top: 20px;
  }
  #stepper-form .v-stepper__step--active {
    border-color: var(--v-primary-base);
    border-bottom-left-radius: 0;
    border-bottom-right-radius: 0;
    border-bottom: none;
  }
  #stepper-form .v-stepper__step--active + .v-stepper__content {
    border: 2px solid var(--v-primary-base);
    border-top: none;
  }
  #stepper-form .v-stepper__content {
    margin: 0;
    border-bottom-left-radius: 5px;
    border-bottom-right-radius: 5px;
    border: none;
    padding: 10px 30px;
  }
}

.v-stepper__label span:first-child {
  margin: 0.5rem 0;
  font-size: 1.2rem;
}

.v-stepper__header {
  box-shadow: none;
}
.v-stepper__step__step {
  width: 30px;
  height: 30px;
}
.v-stepper__step__step .v-icon {
  font-size: 0.8rem;
}
</style>